import React, { useState, useRef, useEffect } from 'react';
import { TopToolbar, RefreshButton, Tab, TabbedShowLayout, Show, ListButton, ShowButton, useRedirect, useNotify, useGetOne } from 'react-admin';
import Select from 'react-select';
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import MomentUtils from '@date-io/moment';
import { RUN_TIME_API_ENDPOINT } from '../common/common'
import { Papa } from '../common/common';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }
    // Starts the upload process.
    upload() {
        return this.loader.file.then(
            file =>
                new Promise((resolve, reject) => {
                    const formData = new FormData();
                    formData.append('image', file);
                    const stateData = localStorage.getItem('__state');
                    const userData = stateData ? JSON.parse(stateData) : false;
                    const apiUrl = RUN_TIME_API_ENDPOINT;
                    const response = fetch(`${apiUrl}/image_upload_to_s3`, {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'Authorization': userData._token,
                        }
                    }).
                        then(res => res.json()).
                        then(res => {
                            resolve({
                                default: res.url
                            });
                            // console.log('res==>', res);
                        });
                })
        );
    }
}

// const cardActionStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const CreateActions = ({ basePath, data }) => (
    <TopToolbar>
        <RefreshButton />
        <ListButton basePath={`/promotions`} />
    </TopToolbar>
)

const EditTitle = ({ record }) => {
    return <span>Edit Promotion Notifications</span>;
};


const PromotionEdit = ({ permissions, ...props }) => {

    const businessListData = useGetOne({
        // type: 'getList',
        resource: `so_business_list`,
        payload: { id: 1 }
    });

    const { data } = useGetOne({
        // type: 'getList',
        resource: `promotions/${props.id}`,
        payload: { id: 1 }
    });


    const promotionData = data || {};
    // console.log('businessListData', businessListData && businessListData.data);
    const businessData = businessListData && businessListData.data;
    const originalRetList = businessData && businessData.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() }));
    const saleOffNameSapCode = businessData && businessData.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() }));

    const [title, setTitle] = useState(null);
    const [summary, setSummary] = useState();
    const [description, setDescription] = useState();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [listImage, setListImage] = useState('');
    const [listImageName, setListImageName] = useState(null);
    const [detailImage, setDetailImage] = useState('');
    const [detailImageName, setDetailImageName] = useState(null);
    const [sendNotification, setSendNotification] = useState(false);
    const [type, setType] = useState(null);
    const [originalList, setOriginalList] = useState(originalRetList)

    const [listImageSizeError, setListImageSizeError] = useState(false)
    const [listImageTypeError, setListImageTypeError] = useState(false)
    const [detailImageSizeError, setDetailImageSizeError] = useState(false)
    const [detailImageTypeError, setDetailImageTypeError] = useState(false)

    const [saveValid, setSaveValid] = useState(false)

    const [unregisteredRetailers, setUnregisteredRetailers] = useState([])
    const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0)
    const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] = useState(0)
    const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] = useState(false)


    const [retailerList, setRetailerList] = useState([])
    const [retailerNameSapCode, setRetailerNameSapCode] = useState([])

    const [showDetailImage, setShowDetailImage] = useState(false)
    const [showListImage, setShowListImage] = useState(false)

    const [loader, setLoader] = useState(false);

    const redirectTo = useRedirect();
    const notify = useNotify();

    useEffect(() => {
        if (saleOffNameSapCode && saleOffNameSapCode.length > 0 && data && Object.keys(data).length > 0) {

            if (data.promotion_mappped_type === 'Business') {
                const addedRetailer = saleOffNameSapCode.filter(i => data.promotion_mapping.find(el => el.promotable_id === i.id))
                setRetailerList(addedRetailer);
            }
            setTitle(data.title);
            setDescription(data.description);
            setSummary(data.summary);
            setType(data.promotion_mappped_type);
        }
    }, [data, businessListData])


    const maxSize = 1;
    const validImagetypes = ['png', 'gif', 'jpg', 'jpeg'];

    const handleListFileChange = (e) => {
        setListImageSizeError(false);
        setListImageTypeError(false);
        const file = e.target.files && e.target.files[0];
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
        if (((file.size / 1024 / 1024) > maxSize)) {
            setListImageSizeError(true)
        } else if (validImagetypes.indexOf(fileType.toLowerCase()) > -1) {
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setListImageName(file);
                    setListImage(reader.result)
                };
                reader.readAsDataURL(file);
            }
        } else {
            setListImageTypeError(true)
        }
    };

    const handleDetailFileChange = (e) => {
        setDetailImageSizeError(false);
        setDetailImageTypeError(false);
        const file = e.target.files && e.target.files[0];
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
        if (((file.size / 1024 / 1024) > maxSize)) {
            setDetailImageSizeError(true);
        } else if (validImagetypes.indexOf(fileType.toLowerCase()) > -1) {
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setDetailImageName(file);
                    setDetailImage(reader.result)
                };
                reader.readAsDataURL(file);
            }
        } else {
            setDetailImageTypeError(true);
        }
    };

    const saveData = () => {
        setLoader(true);
        const summaryText = summary === promotionData.summary ? null : summary;
        const descText = description === promotionData.description ? null : description;
        // const mappingType = type === promotionData.promotion_mappped_type ? null : type;
        const promTitle = title === promotionData.title ? null : title;
        const stateData = localStorage.getItem('__state');
        const userData = stateData ? JSON.parse(stateData) : false;
        const options = {};
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'POST';
        const headers = {
            'Authorization': userData._token,
        };
        
        let imageChanged = false;
        const formData = new FormData();
        const formDataImage = {};
        if (detailImageName || listImageName) {
            formData.append('title', promTitle);
            formData.append('summary', summaryText);
            formData.append('description', descText);
            formData.append('detail_image', detailImageName);
            formData.append('preview_image', listImageName);
            formData.append('starts_at', moment(startDate).startOf('day'));
            formData.append('ends_at', moment(endDate).endOf('day'));
            formData.append('send_notification', sendNotification);
            formData.append('type', type);
            formData.append('name_sap_code', type === 'Country' ? null : JSON.stringify(retailerList));
            options.body = formData;
            imageChanged = true;
        } else {
            formDataImage['title'] = title;
            formDataImage['summary'] = summaryText;
            formDataImage['description'] = descText;
            formDataImage['detail_image'] = detailImageName;
            formDataImage['preview_image'] = listImageName;
            formDataImage['starts_at'] = moment(startDate).startOf('day');
            formDataImage['ends_at'] = moment(endDate).endOf('day');
            formDataImage['type'] = type;
            formDataImage['send_notification'] = sendNotification;
            formDataImage['name_sap_code'] = type === 'Country' ? null : JSON.stringify(retailerList);
            options.body = formDataImage;
            headers['Content-Type'] = 'application/json';
        }

        fetch(`${apiUrl}/promotions/${promotionData && promotionData.id}`, {
            method: 'PUT',
            body: imageChanged ? formData : JSON.stringify(formDataImage),
            headers: headers
        })
        .then(res => {
            return res.json();
        })
        .then(json => {
            setLoader(false);
            notify('ra.notification.updated', 'info', {
                smart_count: 1,
            });
            redirectTo('list', '/promotions');
        }).catch((error) => {
            console.log('error==>', error);
        });
        
    }

    const handleChange = e => {
        const arr = [...originalRetList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalRetList];
        }
        setRetailerList(e);
        setRetailerNameSapCode(result)
    };

    const handleRetailCSVFile = (e) => {
        let file = null;
        file = e.target.files[0];
        if (file === null || typeof (file) === 'undefined' || file === '' || typeof (file) === undefined) {
            console.log('bad file');
        } else {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const parseddata = permissions === 'isSap' ?
                        results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + '-0000' + item.SAPID, label: item.COMPANYNAME + '-0000' + item.SAPID, sap: '0000' + item.SAPID.trim() })) :
                        results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + ' ' + item.SAPID, label: item.COMPANYNAME + ' ' + item.SAPID, sap: item.SAPID.trim() }));
                    console.log(parseddata);
                    let pasrsedSimilarData = [];
                    pasrsedSimilarData = originalRetList.filter(a1 => parseddata.some(a2 => a1.sap === a2.sap));
                    if (pasrsedSimilarData && pasrsedSimilarData.length) {
                        const similarArray = retailerList !== null ? retailerList.filter(({ sap: id1 }) =>
                            !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)) : [];
                        setRetailerList([...similarArray, ...pasrsedSimilarData]);
                        setPasrsedSimilarDataLength(pasrsedSimilarData.length);
                    }
                    const pasrsedDifferentData = parseddata.filter(a1 => pasrsedSimilarData.every(a2 => a1.sap !== a2.sap));
                    if (pasrsedDifferentData && pasrsedDifferentData.length) {
                        console.log(pasrsedDifferentData, pasrsedDifferentData.length)
                        setUnregisteredRetailers([...pasrsedDifferentData]);
                        setPasrsedDifferentDataLength(pasrsedDifferentData.length);
                    }
                }
            });
        }
    }

    const cancelClick = () => {
        setRetailerList([]);
        setRetailerNameSapCode(originalList);
        setUnregisteredRetailers([])
        setPasrsedSimilarDataLength(0)
        setPasrsedDifferentDataLength(0)
    }

    useEffect(() => {
        let valid = !!title && !!description && !!type;
        if (type === 'Business') {
            valid = valid && retailerList && retailerList.length > 0
        }
        setSaveValid(valid);
    }, [title, detailImage, description, listImage, startDate, endDate, type, retailerList])
    return (
        <Show {...props} title={<EditTitle />} actions={<CreateActions permissions={permissions} />}>
            <TabbedShowLayout className="promotion-editpage">
                <Tab label="① Edit">
                    <div className="valid-file-upload">
                        <p>Instructions :</p>
                        <ul>
                            <li>Make changes to the promotion on ① Edit page using the form. Be sure to select both the images. Selecting the Save and send notification checkbox will save as well as send the targeted retailers a push notification of the promotion</li>
                            <li>Go to ② Preview to see how the promotion will look in LeadRetail app</li>
                            <li>Finally Select your target audience in ③ Send To as either a set of retailers or all retailers in your country. You can even select retailers from a CSV list as long as the CSV is in the given format</li>
                        </ul>
                        <br />
                    </div>
                    <div className="so-input">
                        <label>Promotion Title<sup>*</sup></label>
                        <input
                            type="text"
                            name="Title"
                            value={title}
                            onChange={(e) => { setTitle(e.target.value) }}
                        />
                    </div>
                    {
                        showListImage &&
                        <div className="upload-promotion-image">
                            <p className="upload-files-label">Promotion List page image<sup>*</sup></p>
                            <input type="file" onChange={handleListFileChange} />
                            {
                                listImageSizeError &&
                                <div className="so-input-error">File size must be less than 1 MB.</div>
                            }
                            {
                                listImageTypeError &&
                                <div className="so-input-error">File type must include .jpg, .jpeg, .png, .gif</div>
                            }
                            <div className="valid-file-upload">
                                <p>Instructions :</p>
                                <ul>
                                    <li>Allowed file types: Images: JPG Image, JPEG Image, PNG Image, GIF</li>
                                    <li>Max file size (total): 1 MB</li>
                                    <li>Image dimensions: 360 pixels in width & 184 pixels in height</li>
                                </ul>
                            </div>
                        </div>
                    }

                    {
                        !showListImage &&
                        <div>
                            <p className="uploaded-files-label">Promotion List page image uploaded</p>
                            <div className="uploaded-files-container">
                                <div className="complaint-file-content">
                                    <img src={promotionData && promotionData.preview_image} />
                                    <button onClick={() => setShowListImage(true)}>X</button>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="promotion-text-editor">
                        <p className="upload-files-label">List Page Text </p>
                        <CKEditor
                            editor={ClassicEditor}
                            data={summary}
                            onInit={editor => {
                                editor.editing.view.change(writer => {
                                    writer.setStyle(
                                        "min-height",
                                        "200px",
                                        editor.editing.view.document.getRoot()
                                    );
                                });
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setSummary(data);
                            }}
                        />
                    </div>
                    {
                        showDetailImage &&
                        <div className="upload-promotion-image">
                            <p className="upload-files-label">Promotion Notification Homepage Popup image<sup>*</sup></p>
                            <input type="file" onChange={handleDetailFileChange} />
                            {
                                detailImageSizeError &&
                                <div className="so-input-error">File size must be less than 1 MB.</div>
                            }
                            {
                                detailImageTypeError &&
                                <div className="so-input-error">File type must include .jpg, .jpeg, .png, .gif</div>
                            }
                            <div className="valid-file-upload">
                                <p>Instructions :</p>
                                <ul>
                                    <li>Allowed file types: Images: JPG Image, JPEG Image, PNG Image, GIF</li>
                                    <li>Max file size (total): 1 MB</li>
                                    <li>Image dimensions: 640 pixels in width & 918 pixels in height</li>
                                </ul>
                            </div>
                        </div>
                    }
                    {
                        !showDetailImage &&
                        <div>
                            <p className="uploaded-files-label">Promotion Notification Homepage Popup image uploaded</p>
                            <div className="uploaded-files-container">
                                <div className="complaint-file-content">
                                    <img src={promotionData && promotionData.detail_image} />
                                    <button onClick={() => setShowDetailImage(true)}>X</button>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="promotion-text-editor">
                        <p className="upload-files-label"> Detail Page Text<sup>*</sup> </p>
                        <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onInit={editor => {
                                editor.plugins.get("FileRepository").createUploadAdapter = loader => {
                                    return new MyUploadAdapter(loader);
                                };
                                editor.editing.view.change(writer => {
                                    writer.setStyle(
                                        "min-height",
                                        "200px",
                                        editor.editing.view.document.getRoot()
                                    );
                                });
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setDescription(data);
                            }}
                        />
                    </div>
                    <div className="promotion-date">
                        <div>
                            <p className="upload-files-label">Start Date<sup>*</sup></p>
                            {/* <LocalizationProvider adapterLocale={MomentUtils}>
                                <DatePicker
                                    value={startDate === null ? promotionData && promotionData.starts_at : startDate}
                                    onChange={(e) => { setStartDate(e) }}
                                    format="DD/MM/YYYY"
                                    minDate={new Date()}
                                    maxDate={endDate === null ? promotionData && promotionData.ends_at : endDate}
                                />
                            </LocalizationProvider> */}
                        </div>
                        <div>
                            <p className="upload-files-label">End Date<sup>*</sup></p>
                            {/* <LocalizationProvider adapterLocale={MomentUtils}>
                                <DatePicker
                                    value={endDate === null ? promotionData && promotionData.ends_at : endDate}
                                    onChange={(e) => { setEndDate(e) }}
                                    format="DD/MM/YYYY"
                                    minDate={startDate === null ? promotionData && promotionData.starts_at : startDate}
                                // maxDate={this.state.toDate}
                                />
                            </LocalizationProvider> */}
                        </div>
                    </div>
                    {
                        moment(new Date()).format("YYYY-MM-DD") >= moment(startDate || (promotionData && promotionData.starts_at)).format("YYYY-MM-DD") &&
                        <label className="promotion-send-check">
                            <input type="checkbox"
                                checked={sendNotification}
                                onChange={() => { setSendNotification(!sendNotification) }}
                            />
                        Save and send notification
                    </label>
                    }
                    <div className="so-save-button">
                        {
                            loader ? <div className="save-loader" /> :
                                <button
                                    onClick={saveData}
                                    disabled={!saveValid}
                                >
                                    <span>Save</span>
                                </button>
                        }
                    </div>
                </Tab>
                <Tab label="② Preview">
                    <div className="promotion-preview-heading">Promotion Notification Popup</div>
                    <div className="promotion-popup-page-preview">
                        <div className="promotion-popup-preview">
                            <div className="lr-onboarding__close">
                                <span className="icon-close" />
                            </div>
                            <div className="lr-loyalty__schemes__row__description">
                                <div>
                                    <img src={detailImage || (promotionData && promotionData.detail_image)} />
                                </div>
                            </div>
                            <button className="preview-page-btn"><span>View</span></button>
                        </div>
                    </div>
                    <div className="promotion-preview-heading">Promotion List page</div>
                    <div className="promotion-page-preview">
                        <div className="lr-main-view__header">
                            <span className="icon-back" />
                            <span className="preview-page-header">Promotions</span>
                        </div>
                        <div className="lr-loyalty__schemes__row__heading">{title || (promotionData && promotionData.title)}</div>
                        <div className="lr-loyalty__schemes__row_image">
                            <img src={listImage || (promotionData && promotionData.preview_image)} />
                        </div>
                        <div className="lr-loyalty__schemes__row__description" dangerouslySetInnerHTML={{ __html: summary || (promotionData && promotionData.summary) }}>
                            {/*  Rendering html dynamically */}
                        </div>
                        <button className="preview-page-btn"><span>Know More</span></button>
                    </div>
                    <div className="promotion-preview-heading">Promotion Detail page</div>
                    <div className="promotion-page-preview">
                        <div className="lr-main-view__header">
                            <span className="icon-back" />
                            <span className="preview-page-header">Promotion Detail</span>
                        </div>
                        <div className="lr-loyalty__schemes__row__heading">{title || (promotionData && promotionData.title)}</div>
                        <div className="lr-loyalty__schemes__row__description">
                            {/* <div>
                                <img src={detailImage || (promotionData && promotionData.detail_image)} />
                            </div> */}
                            <div dangerouslySetInnerHTML={{ __html: description || (promotionData && promotionData.description) }}>
                                {/* Rendering html dynamically  */}
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab label="③ Send To">
                    <div className="so-input">
                        <label>Notification Send To<sup>*</sup></label>
                        <select className="inapp-notification-sendto" name="type" value={type} onChange={(e) => { setType(e.target.value) }}>
                            <option value="">Select Option</option>
                            <option value="Country">All Retailers</option>
                            <option value="Business">A set of Retailers</option>
                        </select>
                    </div>
                    {
                        type === 'Business' &&
                        <div className="target-upload-container">
                            <div className="csv-file-upload-container"><label>Upload File</label>
                                {/* <input type="file" accept=".csv" name="flies[]" /> */}
                                <input type="file" id="file" accept=".csv" onChange={handleRetailCSVFile} />
                                <div className="valid-file-upload">
                                    <p>Instructions :</p>
                                    <ul>
                                        <li>Only CSV files are allowed with Comma as separator.</li>
                                    </ul>
                                </div>
                                <div className="upload-file-format-download">
                                    <p>To get upload file format. <a
                                        href="https:navendor-global-production.s3-eu-west-1.amazonaws.com/infographics/sample.csv"
                                        target="_blank">Click here</a> to download</p>
                                </div>
                            </div>
                            <div>
                                {
                                    pasrsedSimilarDataLength > 0 ||
                                        pasrsedDifferentDataLength > 0 ?
                                        <div className="csv-result-container">
                                            <label>CSV Result</label>
                                            <div className="csv-result">
                                            <p onClick={() => setUnregisteredRetailersToggle(!unregisteredRetailersToggle)}>
                                                        {pasrsedSimilarDataLength} retailers found, {pasrsedDifferentDataLength} retailers unregistered.
                                                     {pasrsedDifferentDataLength > 0 ? ' Click to view unregistererd retailers' : ''}
                                                        {
                                                            pasrsedDifferentDataLength > 0 ?
                                                                <span className={unregisteredRetailersToggle ? `icon-arrow_down` : `icon-arrow_up`} />
                                                                : ''
                                                        }
                                                    </p>
                                                    {
                                                        pasrsedDifferentDataLength > 0 ?
                                                            <div className={unregisteredRetailersToggle ? `hide-unregistered` : `show-unregistered`}>
                                                                <React.Fragment>
                                                                    {
                                                                        unregisteredRetailers.map(item => (
                                                                            <p key={item.id}>{item.label}</p>
                                                                        ))
                                                                    }
                                                                </React.Fragment>
                                                            </div>
                                                            : ''
                                                    }
                                            </div>
                                        </div> :
                                        ''
                                }
                            </div>
                            <label className="select-label">Choose Retailers<sup>*</sup> (Atleast select one retailer)</label>
                            <div className="select-retailer">
                                <Select
                                    value={retailerList}
                                    onChange={handleChange}
                                    options={saleOffNameSapCode}
                                    isMulti
                                />
                                <button onClick={cancelClick}>Clear</button>
                            </div>
                        </div>

                    }
                    <div className="so-save-button">
                        {
                            loader ? <div className="save-loader" /> :
                                <button
                                    onClick={saveData}
                                    disabled={!saveValid}
                                >
                                    <span>Save</span>
                                </button>
                        }
                    </div>
                </Tab>
            </TabbedShowLayout>
        </Show >
    )
};

export default PromotionEdit;